import {ESRecordResolver} from "../PA.Core/lib/ESRecordResolver";
import {
  WB_ModelCannibalizationRelationshipRow,
  WB_ModelCannibalizationTermRelationshipRow,
  WB_ModelCoefficientRow, WB_ModelConstantRow, WB_ModelFunctionRow,
  WB_ModelTermRelationshipRow,
  WB_ModelTermRow
} from "../PA.Core/PAdbSchemaRows";
import {
  esWB_Model_Cannibalization_Relationship,
  esWB_Model_Cannibalization_Term_Relationship,
  esWB_Model_Coefficient, esWB_Model_Constant, esWB_Model_Function,
  esWB_Model_Term,
  esWB_Model_Term_Relationship
} from "../PA.Core/PAdbSchema";
import {PAdbContext} from "../PA.Core/PAdbContext";
import * as _ from 'lodash'
import {ASync} from "../PA.Core/Basic/ASync";

export interface ICoefficient {
  CoeffId: string,
  CoeffName: string,
  SortOrder?: number
}

export class ModelUtils
{
  private static _dctCoefficientsByModel: {[wbModelId: number]: WB_ModelCoefficientRow[]} = {}
  private static _dctCannCoefficientsByModel: {[wbModelId: number]: WB_ModelCoefficientRow[]} = {}
  private static _dctConstantsByModel: {[wbModelId: number]: WB_ModelConstantRow[]} = {}

  static getModelCoefficientList(wbModelId: number, options: {bSkipCache?: boolean, dbContext?: PAdbContext}): Promise<WB_ModelCoefficientRow[]> {

    let opts = options || {}
    // Check cache
    if(!opts.bSkipCache && _.isEmpty(opts.dbContext)){
      //
      if(wbModelId in ModelUtils._dctCoefficientsByModel){
        return ASync.resolve(ModelUtils._dctCoefficientsByModel[wbModelId])
      }
    }

    return new Promise<WB_ModelCoefficientRow[]>((resolve, error) => {

      // Use record resolver to grab the Model Terms/ Functions
      let aDataStore = opts.dbContext
      if(_.isEmpty(aDataStore)){
        aDataStore  = new PAdbContext()
      }
      let recordResolver: ESRecordResolver = new ESRecordResolver(<any>aDataStore, {
        standardConditions: {
          [esWB_Model_Term_Relationship]: {"DELETED_IND": {"notIn": ['1']}}
        }
      })

      let query = {
        WB_MODEL_ID: wbModelId,
        DELETED_IND: {"notIn": ['1']}
      }

      let findQuery: any = {where: query}

      recordResolver.queryAllWithRelationships(esWB_Model_Term_Relationship, findQuery)
        .then((arrModelTermRs: WB_ModelTermRelationshipRow[]) => {

          //
          let arrModelTerms: WB_ModelTermRow[] = _.map(arrModelTermRs, (aRow: WB_ModelTermRelationshipRow) => {
            return aRow.WB_ModelTermRow
          })
          let arrCoeffs: WB_ModelCoefficientRow[] = []
          let dctCoeffs: {[coef_id:string]: WB_ModelCoefficientRow} = {}

          async function getModelCoefficients() {
            for(var i=0; i<arrModelTerms.length;i++){
              console.log(i)
              let aTerm = arrModelTerms[i]
              if (!aTerm.WB_ModelFunctionRow) {
                return
              }

              if (aTerm.WB_ModelFunctionRow.cif.COEFFICIENT_COUNT > 0) {
                if ((aTerm.cif.WB_MODEL_COEFFICIENT_ID != 0) && !(aTerm.cif.WB_MODEL_COEFFICIENT_ID in dctCoeffs)) {
                  let modelCoeffRow: WB_ModelCoefficientRow = await aDataStore.find(esWB_Model_Coefficient, aTerm.cif.WB_MODEL_COEFFICIENT_ID)
                  let coeff1 = modelCoeffRow
                  arrCoeffs.push(coeff1)
                  dctCoeffs[coeff1.cif.WB_MODEL_COEFFICIENT_ID] = coeff1
                }
              }

              if (aTerm.WB_ModelFunctionRow.cif.COEFFICIENT_COUNT > 1) {
                if ((aTerm.cif.WB_MODEL_COEFFICIENT_ID2 != 0) && !(aTerm.cif.WB_MODEL_COEFFICIENT_ID2 in dctCoeffs)) {
                  let modelCoeffRow2: WB_ModelCoefficientRow = await aDataStore.find(esWB_Model_Coefficient, aTerm.cif.WB_MODEL_COEFFICIENT_ID2)
                  let coeff2 = modelCoeffRow2
                  arrCoeffs.push(coeff2)
                  dctCoeffs[coeff2.cif.WB_MODEL_COEFFICIENT_ID] = coeff2
                }
              }

              if (aTerm.WB_ModelFunctionRow.cif.COEFFICIENT_COUNT > 2) {
                if ((aTerm.cif.WB_MODEL_COEFFICIENT_ID3 != 0) && !(aTerm.cif.WB_MODEL_COEFFICIENT_ID3 in dctCoeffs)) {
                  let modelCoeffRow3: WB_ModelCoefficientRow = await aDataStore.find(esWB_Model_Coefficient, aTerm.cif.WB_MODEL_COEFFICIENT_ID3)
                  let coeff3 = modelCoeffRow3
                  arrCoeffs.push(coeff3)
                  dctCoeffs[coeff3.cif.WB_MODEL_COEFFICIENT_ID] = coeff3
                }
              }

              if (aTerm.WB_ModelFunctionRow.cif.COEFFICIENT_COUNT > 3) {
                if ((aTerm.cif.WB_MODEL_COEFFICIENT_ID4 != 0) && !(aTerm.cif.WB_MODEL_COEFFICIENT_ID4 in dctCoeffs)) {
                  let modelCoeffRow4: WB_ModelCoefficientRow = await aDataStore.find(esWB_Model_Coefficient, aTerm.cif.WB_MODEL_COEFFICIENT_ID4)
                  let coeff4 = modelCoeffRow4
                  arrCoeffs.push(coeff4)
                  dctCoeffs[coeff4.cif.WB_MODEL_COEFFICIENT_ID] = coeff4
                }
              }
            }

            // Sort
            //arrCoeffs = _.sortBy(arrCoeffs, ['SortOrder','CoeffName'])

            ModelUtils._dctCoefficientsByModel[wbModelId] = arrCoeffs
            resolve(arrCoeffs)
          }

          getModelCoefficients()
        })
        .catch((err) => {
          error(err)
        })
    })

  }

  static getModelConstantList(wbModelId: number, options: {bSkipCache?: boolean, dbContext?: PAdbContext}): Promise<WB_ModelConstantRow[]> {

    let opts = options || {}
    // Check cache
    if(!opts.bSkipCache && _.isEmpty(opts.dbContext)){
      //
      if(wbModelId in ModelUtils._dctConstantsByModel){
        return ASync.resolve(ModelUtils._dctConstantsByModel[wbModelId])
      }
    }

    return new Promise<WB_ModelConstantRow[]>((resolve, error) => {

      // Use record resolver to grab the Model Terms/ Functions
      let aDataStore = opts.dbContext
      if(_.isEmpty(aDataStore)){
        aDataStore  = new PAdbContext()
      }
      let recordResolver: ESRecordResolver = new ESRecordResolver(<any>aDataStore, {
        standardConditions: {
          [esWB_Model_Term_Relationship]: {"DELETED_IND": {"notIn": ['1']}}
        }
      })

      let query = {
        WB_MODEL_ID: wbModelId,
        DELETED_IND: {"notIn": ['1']}
      }

      let findQuery: any = {where: query}

      recordResolver.queryAllWithRelationships(esWB_Model_Term_Relationship, findQuery)
          .then((arrModelTermRs: WB_ModelTermRelationshipRow[]) => {

            //
            let arrModelTerms: WB_ModelTermRow[] = _.map(arrModelTermRs, (aRow: WB_ModelTermRelationshipRow) => {
              return aRow.WB_ModelTermRow
            })
            let arrConstants: WB_ModelConstantRow[] = []
            let dctConstants: {[constant_id:string]: WB_ModelConstantRow} = {}

            async function getModelConstants() {
              for(var i=0; i<arrModelTerms.length;i++){
                let aTerm = arrModelTerms[i]
                if (!aTerm.WB_ModelFunctionRow) {
                  return
                }

                if (aTerm.WB_ModelFunctionRow.cif.CONSTANT_COUNT > 0) {
                  if ((aTerm.cif.WB_MODEL_CONSTANT_ID != 0) && !(aTerm.cif.WB_MODEL_CONSTANT_ID in dctConstants)) {
                    let modelCoeffRow: WB_ModelConstantRow = await aDataStore.find(esWB_Model_Constant, aTerm.cif.WB_MODEL_CONSTANT_ID)
                    let coeff1 = modelCoeffRow
                    arrConstants.push(coeff1)
                    dctConstants[coeff1.cif.WB_MODEL_CONSTANT_ID] = coeff1
                  }
                }

                if (aTerm.WB_ModelFunctionRow.cif.CONSTANT_COUNT > 1) {
                  if ((aTerm.cif.WB_MODEL_CONSTANT_ID2 != 0) && !(aTerm.cif.WB_MODEL_CONSTANT_ID2 in dctConstants)) {
                    let modelCoeffRow2: WB_ModelConstantRow = await aDataStore.find(esWB_Model_Constant, aTerm.cif.WB_MODEL_CONSTANT_ID2)
                    let coeff2 = modelCoeffRow2
                    arrConstants.push(coeff2)
                    dctConstants[coeff2.cif.WB_MODEL_CONSTANT_ID] = coeff2
                  }
                }

                if (aTerm.WB_ModelFunctionRow.cif.CONSTANT_COUNT > 2) {
                  if ((aTerm.cif.WB_MODEL_CONSTANT_ID3 != 0) && !(aTerm.cif.WB_MODEL_CONSTANT_ID3 in dctConstants)) {
                    let modelCoeffRow3: WB_ModelConstantRow = await aDataStore.find(esWB_Model_Constant, aTerm.cif.WB_MODEL_CONSTANT_ID3)
                    let coeff3 = modelCoeffRow3
                    arrConstants.push(coeff3)
                    dctConstants[coeff3.cif.WB_MODEL_CONSTANT_ID] = coeff3
                  }
                }

                if (aTerm.WB_ModelFunctionRow.cif.CONSTANT_COUNT > 3) {
                  if ((aTerm.cif.WB_MODEL_CONSTANT_ID4 != 0) && !(aTerm.cif.WB_MODEL_CONSTANT_ID4 in dctConstants)) {
                    let modelCoeffRow4: WB_ModelConstantRow = await aDataStore.find(esWB_Model_Constant, aTerm.cif.WB_MODEL_CONSTANT_ID4)
                    let coeff4 = modelCoeffRow4
                    arrConstants.push(coeff4)
                    dctConstants[coeff4.cif.WB_MODEL_CONSTANT_ID] = coeff4
                  }
                }
              }

              // Sort
              //arrCoeffs = _.sortBy(arrCoeffs, ['SortOrder','CoeffName'])

              ModelUtils._dctConstantsByModel[wbModelId] = arrConstants
              resolve(arrConstants)
            }

            getModelConstants()
          })
          .catch((err) => {
            error(err)
          })
    })

  }

  static async getModelCannCoefficientList(wbModelId: number, options: { bSkipCache?: boolean, dbContext?: PAdbContext }): Promise<WB_ModelCoefficientRow[]> {

    let opts = options || {}
    // Check cache
    if (!opts.bSkipCache && _.isEmpty(opts.dbContext)) {
      //
      if (wbModelId in ModelUtils._dctCannCoefficientsByModel) {
        return ModelUtils._dctCannCoefficientsByModel[wbModelId]
      }
    }

    try {
      // Use record resolver to grab the Model Terms/ Functions
      let aDataStore = opts.dbContext
      if (_.isEmpty(aDataStore)) {
        aDataStore = new PAdbContext()
      }
      let recordResolver: ESRecordResolver = new ESRecordResolver(<any>aDataStore, {
        standardConditions: {
          [esWB_Model_Cannibalization_Term_Relationship]: {"DELETED_IND": {"notIn": ['1']}}
        }
      })
      let query = {
        WB_MODEL_ID: wbModelId,
        DELETED_IND: {"notIn": ['1']}
      }

      let findQuery: any = {where: query}

      let arrModelCannRs: WB_ModelCannibalizationRelationshipRow[] = <any>await recordResolver.queryAllWithRelationships(esWB_Model_Cannibalization_Relationship, findQuery)

      //
      let dctCoeffs: { [coef_id: string]: number } = {}

      for(let aRow of arrModelCannRs){
        if(!aRow.isActive)
          continue

        let aFunction: WB_ModelFunctionRow = <any> await aDataStore.find(esWB_Model_Function,aRow.cif.WB_MODEL_FUNCTION_ID)
        if(_.isEmpty(aFunction))
          continue

        if(aFunction.cif.COEFFICIENT_COUNT >= 1 && aRow.cif.WB_MODEL_COEFFICIENT_ID > 0){
            dctCoeffs[aRow.cif.WB_MODEL_COEFFICIENT_ID] = aRow.cif.WB_MODEL_COEFFICIENT_ID
        }

        if(aFunction.cif.COEFFICIENT_COUNT >= 2 && aRow.cif.WB_MODEL_COEFFICIENT_ID2 > 0){
          dctCoeffs[aRow.cif.WB_MODEL_COEFFICIENT_ID2] = aRow.cif.WB_MODEL_COEFFICIENT_ID2
        }
      }

      let arrCoeffs: WB_ModelCoefficientRow[] = []
      if(!_.isEmpty(dctCoeffs))
        arrCoeffs = <any> await aDataStore.findUsingCache(esWB_Model_Coefficient, _.values(dctCoeffs))

      ModelUtils._dctCannCoefficientsByModel[wbModelId] = arrCoeffs
      return arrCoeffs
    } catch (err) {
      throw err
    }

  }

}
